export default __webpack_public_path__ + "static/media/robe_of_fiendish_invocation.9048158f.jpg";